import { render, staticRenderFns } from "./MultipollChoiceInputs.vue?vue&type=template&id=26fa9026&scoped=true&"
import script from "./MultipollChoiceInputs.vue?vue&type=script&lang=ts&"
export * from "./MultipollChoiceInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa9026",
  null
  
)

export default component.exports